<template>
  <section class="section-202 container-fluid w-100 position-relative">
    <div class="section-202-content position-sticky text-center ">
      <slot>Test Content</slot>
    </div>
    <div class="row">
      <div class="content-right col-md-6 col-sm-12 p-0 m-0 ">
        <m-img v-if=" sectionRightMediaType === 'image' " class="section-202-image  object-fit-cover"
               :src="sectionRightImage" :alt="sectionRightAlt"/>
        <video  v-else class="section-201-video w-100  object-fit-cover" :muted="muted" :autoplay="autoplay"
               :loop="loop">
          <source :src="sectionRightVideoSrc" type="video/mp4"/>
          Your browser does not support the video tag.
        </video>
      </div>

      <div class="content-left col-md-6 col-sm-12 p-0  right-section">
        <m-img v-if=" sectionLeftMediaType === 'image' "
               class="section-202-image   object-fit-cover"
               :src="sectionLeftImage" :alt="sectionLeftAlt"/>
        <video v-else class="section-201-video w-100  object-fit-cover" :muted="muted" :autoplay="autoplay"
               :loop="loop">
          <source :src="sectionLeftVideoSrc" type="video/mp4"/>
          Your browser does not support the video tag.
        </video>
      </div>
    </div>


  </section>
</template>

<script>
import mImg from "../Tags/Img";
import {videoProps} from "../Tags/VideoProps";

export default {
  name: "Section202",
  components: {
    mImg,
  },
  props: {
    sectionRightMediaType: {
      default: 'image',
      options: ['video', 'image'],
    },
    sectionLeftMediaType: {
      default: 'image',
      options: ['video', 'image'],
    },
    sectionRightImage: {
      default: 'https://picsum.photos/1280/722'
    },
    sectionLeftImage: {
      default: 'https://picsum.photos/1280/722'
    },
    sectionRightAlt: {
      default: 'mix it web'
    },
    sectionLeftAlt: {
      default: 'mix it web'
    },
    sectionRightVideoSrc: {
      default: ''
    },
    sectionLeftVideoSrc: {
      default: ''
    },
    ...videoProps,
  },
  mounted() {
    // Check if the video is in fullscreen mode
    function isVideoFullscreen() {
      return !!document.fullscreenElement || !!document.webkitFullscreenElement || !!document.mozFullScreenElement || !!document.msFullscreenElement;
    }

    // Exit fullscreen mode when the video enters fullscreen
    document.addEventListener("fullscreenchange", function () {
      if (isVideoFullscreen()) {
        exitFullscreen();
      }
    });

    // Exit fullscreen mode when the video enters fullscreen
    document.addEventListener("webkitfullscreenchange", function () {
      if (isVideoFullscreen()) {
        exitFullscreen();
      }
    });

    // Exit fullscreen mode when the video enters fullscreen
    document.addEventListener("mozfullscreenchange", function () {
      if (isVideoFullscreen()) {
        exitFullscreen();
      }
    });

    // Exit fullscreen mode when the video enters fullscreen
    document.addEventListener("MSFullscreenChange", function () {
      if (isVideoFullscreen()) {
        exitFullscreen();
      }
    });

    // Function to exit fullscreen mode
    function exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }
}
</script>

<style scoped>

.right-section {
  margin: 200px 0 0 0;
}

.section-202-image {
  object-fit: cover !important;
  height: 500px;
  width: 100%;
}

.section-201-video {
  object-fit: cover !important;
  height: 500px;
}

.section-202-content {
  z-index: 100;
  top: 0;
  mix-blend-mode: difference !important;

  font-size: 4.5rem !important;
  background: -webkit-linear-gradient(#eee, #333);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  /*background: linear-gradient(*/
  /*    to right,*/
  /*    #3b3a3b 20%,*/
  /*    #88949a 30%,*/
  /*    #dfe8ec 70%,*/
  /*    #764ada 80%*/
  /*);*/
  /*-webkit-background-clip: text;*/
  /*background-clip: text;*/
  /*-webkit-text-fill-color: transparent;*/
  /*text-fill-color: transparent;*/
  /*background-size: 500% auto;*/
  /*animation: textShine 5s ease-in-out infinite alternate;*/
}

@keyframes textShine {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}
</style>